/** Подсказка отметки — у ячейки вкладки и у точки списка: имя, под ним комментарий; цвета словами не называются */
export function FlagTip({ name, note }: { name: string; note: string | null }) {
  return (
    <span className="nd:block">
      <span className="nd:block nd:font-semibold">{name}</span>
      {note ? <span className="nd:block nd:whitespace-pre-line">{note}</span> : null}
    </span>
  );
}
